var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"common",
		"authentication-authentication-module"
	],
	"./customer/customer.module": [
		"./src/app/customer/customer.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"common",
		"customer-customer-module"
	],
	"./dashboards/dashboard.module": [
		"./src/app/dashboards/dashboard.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"default~dashboards-dashboard-module~order-order-module~ps-ps-module~purchase-purchase-module~reports~5ea71730",
		"default~dashboards-dashboard-module~reports-reports-module~user-management-user-management-module",
		"default~dashboards-dashboard-module~user-management-user-management-module",
		"common",
		"dashboards-dashboard-module"
	],
	"./extra-component/extra-component.module": [
		"./src/app/extra-component/extra-component.module.ts",
		"default~extra-component-extra-component-module~order-order-module~ps-ps-module~user-management-user-~9eb0da3c",
		"default~extra-component-extra-component-module~ps-ps-module",
		"common",
		"extra-component-extra-component-module"
	],
	"./order/order.module": [
		"./src/app/order/order.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"default~dashboards-dashboard-module~order-order-module~ps-ps-module~purchase-purchase-module~reports~5ea71730",
		"default~extra-component-extra-component-module~order-order-module~ps-ps-module~user-management-user-~9eb0da3c",
		"default~order-order-module~user-management-user-management-module",
		"default~order-order-module~reports-reports-module",
		"common",
		"order-order-module"
	],
	"./payment/payment.module": [
		"./src/app/payment/payment.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"common",
		"payment-payment-module"
	],
	"./ps/ps.module": [
		"./src/app/ps/ps.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"default~dashboards-dashboard-module~order-order-module~ps-ps-module~purchase-purchase-module~reports~5ea71730",
		"default~extra-component-extra-component-module~order-order-module~ps-ps-module~user-management-user-~9eb0da3c",
		"default~extra-component-extra-component-module~ps-ps-module",
		"common",
		"ps-ps-module"
	],
	"./purchase/purchase.module": [
		"./src/app/purchase/purchase.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"default~dashboards-dashboard-module~order-order-module~ps-ps-module~purchase-purchase-module~reports~5ea71730",
		"common",
		"purchase-purchase-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"default~dashboards-dashboard-module~order-order-module~ps-ps-module~purchase-purchase-module~reports~5ea71730",
		"default~dashboards-dashboard-module~reports-reports-module~user-management-user-management-module",
		"default~order-order-module~reports-reports-module",
		"common",
		"reports-reports-module"
	],
	"./user-management/user-management.module": [
		"./src/app/user-management/user-management.module.ts",
		"default~customer-customer-module~dashboards-dashboard-module~order-order-module~payment-payment-modu~06b4ae14",
		"default~dashboards-dashboard-module~order-order-module~ps-ps-module~purchase-purchase-module~reports~5ea71730",
		"default~extra-component-extra-component-module~order-order-module~ps-ps-module~user-management-user-~9eb0da3c",
		"default~dashboards-dashboard-module~reports-reports-module~user-management-user-management-module",
		"default~dashboards-dashboard-module~user-management-user-management-module",
		"default~order-order-module~user-management-user-management-module",
		"common",
		"user-management-user-management-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;